<form [formGroup]="confirmCodeForm" (change)="updateValue()">
    <div formArrayName="digits">
        <input *ngFor="let field of confirmCodeForm.get('digits')?.controls; let i = index" #inputs [maxLength]="1"
            autocomplete="none" (paste)="onPaste($event)" [formControlName]="i" (keydown)="check(i, field, $event);"
            (keyup)="updateValue()" inputmode="numeric" pattern="[0-9]*">
    </div>
</form>